import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/dist/query/react';
import { spotFinder } from './endpoints';

export const posApi = createApi({
  reducerPath: 'posApi',
  baseQuery: fetchBaseQuery({ baseUrl: process.env.REACT_APP_SPOT_FINDER_BASE_URL }),
  tagTypes: ['pos'],
  endpoints: (builder) => ({
    startPayment: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.posController.startPayment}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    checkStatus: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.posController.checkStatus}/${body.requestId}`,
          method: 'GET',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
    cancelPayment: builder.mutation({
      query(body) {
        return {
          url: `${spotFinder.posController.cancelPayment}`,
          method: 'POST',
          headers: { Authorization: `Bearer ${body.token}` },
          body: body.payload,
        };
      },
    }),
  }),
});

export const { useStartPaymentMutation, useCheckStatusMutation, useCancelPaymentMutation } = posApi;
